import apiClient from '../apiClient';
import { GET_TOUR_GUIDE_BY_ID_URL } from '../apiUrl';

const getTourGuideByIdApi = Id => {
  return apiClient.get(GET_TOUR_GUIDE_BY_ID_URL(Id));
};

export default getTourGuideByIdApi;
